import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function Modal({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={onClose} data-id="element-68">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-69" />
      <div className="relative bg-[#151820] border border-[#2a2d3a] rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-70">
        <div className="sticky top-0 bg-[#151820] border-b border-[#2a2d3a] px-6 py-4 flex items-center justify-between" data-id="element-71">
          <h2 className="text-lg font-bold text-text-primary" data-id="element-72">{title}</h2>
          <button onClick={onClose} className="text-text-secondary hover:text-text-primary transition-colors p-1" data-id="element-73">
            <XIcon className="w-5 h-5" data-id="element-74" />
          </button>
        </div>
        <div className="px-6 py-6 text-sm text-text-secondary leading-relaxed space-y-4" data-id="element-75">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-dark-bg py-10 border-t border-dark-border px-4 sm:px-6 text-center" data-id="element-76">
        <div className="max-w-6xl mx-auto" data-id="element-77">
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-78">
            <button onClick={() => setOpenModal('privacy')} className="text-text-secondary hover:text-gold text-sm transition-colors" data-id="element-79">
              Privacy Policy
            </button>
            <span className="w-1 h-1 bg-dark-border rounded-full" data-id="element-80" />
            <button onClick={() => setOpenModal('terms')} className="text-text-secondary hover:text-gold text-sm transition-colors" data-id="element-81">
              Terms of Service
            </button>
          </div>
          <p className="text-text-secondary text-sm mb-4" data-id="element-82">
            © {new Date().getFullYear()} Erectile Diffusion Guide. All rights
            reserved.
          </p>
          <p className="text-text-secondary/50 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-83">
            This product does not replace professional medical advice,
            diagnosis, or treatment. Always seek the advice of your physician or
            other qualified health provider with any questions you may have
            regarding a medical condition.
          </p>
        </div>
      </footer>

      {openModal === 'privacy' && <Modal title="Privacy Policy" onClose={() => setOpenModal(null)} data-id="element-84">
          <p data-id="element-85">
            <strong className="text-text-primary" data-id="element-86">Last updated:</strong> March
            2026
          </p>
          <p data-id="element-87">
            Your privacy is important to us. This Privacy Policy explains how we
            collect, use, and protect your personal information when you
            purchase and use our digital products.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-88">
            Information We Collect
          </h3>
          <p data-id="element-89">
            We collect only the information necessary to process your purchase:
            your email address and payment details. Payment processing is
            handled by secure third-party providers. We do not store credit card
            information on our servers.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-90">
            How We Use Your Information
          </h3>
          <p data-id="element-91">
            Your email is used solely to deliver your purchased product and
            provide customer support. We do not sell, rent, or share your
            personal information with third parties for marketing purposes.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-92">Data Security</h3>
          <p data-id="element-93">
            We implement industry-standard security measures to protect your
            personal information. All transactions are encrypted using SSL
            technology.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-94">Cookies</h3>
          <p data-id="element-95">
            Our website may use cookies to improve your browsing experience and
            analyze site traffic. You can disable cookies in your browser
            settings at any time.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-96">Your Rights</h3>
          <p data-id="element-97">
            You have the right to request access to, correction of, or deletion
            of your personal data. To exercise these rights, please reach out
            through the platform where you made your purchase.
          </p>
        </Modal>}

      {openModal === 'terms' && <Modal title="Terms of Service" onClose={() => setOpenModal(null)} data-id="element-98">
          <p data-id="element-99">
            <strong className="text-text-primary" data-id="element-100">Last updated:</strong> March
            2026
          </p>
          <p data-id="element-101">
            By purchasing and accessing this digital product, you agree to the
            following terms and conditions.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-102">
            Product Description
          </h3>
          <p data-id="element-103">
            This is a digital information product delivered in PDF format. It
            provides educational content related to mental performance
            strategies. It is not a medical device, medication, or substitute
            for professional medical advice.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-104">Refund Policy</h3>
          <p data-id="element-105">
            We offer a 7-day money-back guarantee from the date of purchase. If
            you are not satisfied with the product, you may request a full
            refund within this period. No questions asked.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-106">
            Intellectual Property
          </h3>
          <p data-id="element-107">
            All content within this product is protected by copyright. You may
            not reproduce, distribute, or share the content without written
            permission. Your purchase grants you a personal, non-transferable
            license to use the material.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-108">Disclaimer</h3>
          <p data-id="element-109">
            The information provided in this guide is for educational purposes
            only. Results may vary. This product does not guarantee specific
            outcomes. Always consult a qualified healthcare professional before
            making changes to your health routine.
          </p>
          <h3 className="text-text-primary font-bold mt-2" data-id="element-110">
            Limitation of Liability
          </h3>
          <p data-id="element-111">
            To the maximum extent permitted by law, we shall not be liable for
            any indirect, incidental, or consequential damages arising from the
            use of this product.
          </p>
        </Modal>}
    </>;
}